$(".js-function-accordion .accordion-header").click(function(){
  $(this).parent(".accordion-item").toggleClass("open");
});
